import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';

import vixPeekingFront from '../../assets/Vix/vix-peeking-front.webp';

/**
 * VixPortfolioCallout
 *
 * Spotlight wrapper that highlights the portfolio section when the user
 * arrives from the VixFloatingBubble hint.
 *
 * Renders a glowing border around children + a floating Vix callout above.
 *
 * Props:
 *   active    – boolean, whether the spotlight is showing
 *   onDismiss – callback to remove the spotlight
 *   children  – the portfolio section JSX to wrap
 */
const VixPortfolioCallout = ({ active, onDismiss, children }) => {
  const wrapRef = useRef(null);

  // Scroll into view when activated
  useEffect(() => {
    if (active && wrapRef.current) {
      setTimeout(() => {
        wrapRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 200);
    }
  }, [active]);

  return (
    <div ref={wrapRef} className={`vix-portfolio-spotlight${active ? ' vix-portfolio-spotlight--active' : ''}`}>
      <AnimatePresence>
        {active && (
          <motion.div
            className="vix-portfolio-callout"
            initial={{ opacity: 0, y: -12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.95 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
          >
            <img src={vixPeekingFront} alt="Vix" className="vix-portfolio-callout-img" aria-hidden="true" />
            <div className="vix-portfolio-callout-bubble">
              <p className="vix-portfolio-callout-text">
                Sube tu primer proyecto para ser más visible a las marcas
              </p>
              <button
                type="button"
                className="vix-portfolio-callout-close"
                onClick={onDismiss}
                aria-label="Cerrar sugerencia"
              >
                <FiX />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      {children}
    </div>
  );
};

export default VixPortfolioCallout;
